if (!customElements.get("product-add-ons")) {
  class ComponentAddOns extends HTMLElement {
    constructor() {
      super();

      this.addOnsData = JSON.parse(
        this.querySelector('[type="application/json"][data-addons-json]')
          .textContent
      );

      this.parentId = this.dataset.parentId;
      this.parentTitle = this.dataset.parentTitle;
      this.parentProperty = this.dataset.parentProperty;

      this.mainElement = this.closest(".product-main-element");
      this.btnsAdd = this.querySelectorAll(".btn-add");
      this.btnsRemove = this.querySelectorAll(".btn-remove");

      this.initButtons();
    }

    initButtons() {
      this.btnsAdd.forEach((btnAdd) => {
        btnAdd.addEventListener("click", (event) => {
          event.preventDefault();
          this.addProduct(
            event.currentTarget.closest(".add-on").dataset.product
          );
        });
      });
      this.btnsRemove.forEach((btnRemove) => {
        btnRemove.addEventListener("click", (event) => {
          event.preventDefault();
          this.removeProduct(
            event.currentTarget.closest(".add-on").dataset.product
          );
        });
      });
    }

    getAddOns() {
      return this.mainElement.dataset.addOns
        ? this.mainElement.dataset.addOns
            .split(",")
            .map((addOn) =>
              this.addOnsData.find(
                (addOnData) => parseInt(addOnData.productId) === parseInt(addOn)
              )
            )
        : [];
    }

    addProduct(productId) {
      console.log('her22');
      this.mainElement.dataset.addOns = this.mainElement.dataset.addOns
        ? [...this.mainElement.dataset.addOns.split(","), productId].join(",")
        : productId;
      this.updateAddOns();
    }

    removeProduct(productId) {
      this.mainElement.dataset.addOns = this.mainElement.dataset.addOns
        ? this.mainElement.dataset.addOns
            .split(",")
            .filter((addOn) => parseInt(addOn) != parseInt(productId))
            .join(",")
        : "";
      this.updateAddOns();
    }

    clearAddOns() {
      let addOnProducts = this.querySelectorAll(".add-on");
      addOnProducts.forEach((addOnProduct) =>
        addOnProduct.classList.remove("added")
      );
      let addedProducts = this.mainElement.querySelectorAll(".add-on-product");
      addedProducts.forEach((product) => product.remove());
    }

    getCurrentAddOns() {
      let addOns = this.mainElement.dataset.addOns
        ? this.mainElement.dataset.addOns.split(",")
        : [];
      return addOns.map((addOn) =>
        this.addOnsData.find(
          (addOnData) => parseInt(addOnData.productId) === parseInt(addOn)
        )
      );
    }

    updateAddOns() {
      this.clearAddOns();
      let addOns = this.mainElement.dataset.addOns
        ? this.mainElement.dataset.addOns.split(",")
        : [];
      addOns.forEach((productId, indexAddOn) => {
        this.querySelector(
          `.add-on[data-product="${productId}"]`
        ).classList.add("added");
        let inputEl = document.createElement("input");
        inputEl.type = "hidden";
        inputEl.name = `items[${indexAddOn}][id]`;
        inputEl.value = productId;
        inputEl.classList.add(`add-on-${productId}`);
        inputEl.classList.add(`add-on-product`);
        this.mainElement.querySelector("form").appendChild(inputEl);

        let inputElParentId = document.createElement("input");
        inputElParentId.type = "hidden";
        inputElParentId.name = `items[${indexAddOn}][properties[_parent_product_id]]`;
        inputElParentId.value = this.parentId;
        inputElParentId.classList.add(`add-on-${productId}`);
        inputElParentId.classList.add(`add-on-product`);
        this.mainElement.querySelector("form").appendChild(inputElParentId);

        let inputElParentFor = document.createElement("input");
        inputElParentFor.type = "hidden";
        inputElParentFor.name = `items[${indexAddOn}][properties[${this.parentProperty}]]`;
        inputElParentFor.value = this.parentTitle;
        inputElParentFor.classList.add(`add-on-${productId}`);
        inputElParentFor.classList.add(`add-on-product`);
        this.mainElement.querySelector("form").appendChild(inputElParentFor);

      });
      this.mainElement.dispatchEvent(
        new CustomEvent("addOnsUpdated", {
          detail: addOns.map((addOn) =>
            this.addOnsData.find(
              (addOnData) => parseInt(addOnData.productId) === parseInt(addOn)
            )
          ),
        })
      );
    }
  }
  customElements.define("product-add-ons", ComponentAddOns);
}

if (!customElements.get("addons-added")) {
  class ComponentAddonsAdded extends HTMLElement {
    constructor() {
      super();

      this.mainElement = document.querySelector(".product-main-element");
      this.addOnsMainElement = document.querySelector("product-add-ons");
      this.addOnsList = this.querySelector(".addons-list");
      this.initListeners();
    }

    initListeners() {
      this.mainElement.addEventListener("addOnsUpdated", (event) => {
        if (event.detail.length > 0) {
          this.classList.remove("visually-hidden");
        } else {
          this.classList.add("visually-hidden");
        }
        this.updateButtons(event.detail);
      });
    }

    updateButtons(products) {
      let buttons = this.querySelectorAll(".btn-added");
      buttons.forEach((button) => button.remove());
      products.forEach((product) => {
        let buttonEl = document.createElement("button");
        buttonEl.classList.add("flex", "align-items-center", "btn-added");
        buttonEl.ariaLabel = `Remove {title} from cart`.replace(
          "{title}",
          product.title
        );
        buttonEl.innerHTML = `<div>
          <svg aria-hidden="true" role="icon" class="icon icon-minus" viewBox="0 0 32 32"><path d="M1.8,16H30.2"/></svg></div>
          <span>${product.title}</span>`;
        buttonEl.dataset.product = product.productId;
        this.addOnsList.appendChild(buttonEl);
      });
      this.initButtons();
    }
    initButtons() {
      let buttonsEl = this.querySelectorAll(".btn-added");
      buttonsEl.forEach((buttonEl) => {
        buttonEl.addEventListener("click", (event) => {
          event.preventDefault();
          this.addOnsMainElement.removeProduct(
            event.currentTarget.dataset.product
          );
        });
      });
    }
  }
  customElements.define("addons-added", ComponentAddonsAdded);
}
